import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { toman } from "../../../auxiliary/shop/ShopPage";
import WalletPrefactor from "../../../auxiliary/shop/WalletPrefactor";

export const BILL_STEPS = ["صورتحساب", "پیش فاکتور", "رسید"];
const SHOP = _adr.PayBill.Index + _adr.PayBill.Shop;

const PrefactorPayBill = () => {
	const [t] = useTranslation("global");
	const { callBackBillingToNeginWallet } = useDealer();

	// the whole debt is paid from the wallet, no tax or commission
	const invoice = (order) => {
		const amount = order?.depositAmount;
		return {
			details: (
				<div className="list-item">
					<div className="item">
						<div className="label">مبلغ صورتحساب:</div>
						<div className="value">{toman(amount)}</div>
					</div>
				</div>
			),
			rows: [
				["مبلغ بدهی", amount],
				["مبلغ قابل دریافت از مشتری", amount],
				["مبلغ برداشت از کیف پول", amount],
			],
			walletDebit: amount,
		};
	};

	return (
		<WalletPrefactor
			title={t("payBill.title")}
			prefix="sp"
			steps={BILL_STEPS}
			simLabel="سیم‌کارت دائمی"
			// ponytail: the bill shares the "dcCharge" slot and the charge wallet plan with direct charge, as it always has
			stateKey="dcCharge"
			chargePlanId={process.env.REACT_APP_PLANID_CHARGE_WALLET_DC}
			invoice={invoice}
			pay={(order) => callBackBillingToNeginWallet({ paybillid: order?.payBillId })}
			finalPath={SHOP + _adr.PayBill.Final}
			finalState={(response) => ({ ...response })}
			backPath={SHOP + _adr.PayBill.Bill}
			showPurchase={false}
		/>
	);
};

export default PrefactorPayBill;
